import React from "react";
import styles from "./modal-title.module.scss";

interface ModalTitleProps {
    title?: string;
    subtitle?: string;
}

export const ModalTitle: React.FC<ModalTitleProps> = ({ title, subtitle }) => {
    return (
        <div className={styles.header}>
            <span className={styles.header__title}>{title}</span>
            <span className={styles.header__subtitle}>{subtitle}</span>
            <hr className={styles.header__line}></hr>
        </div>
    );
};
